import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-sales-tax-abstract',
  templateUrl: './sales-tax-abstract.component.html',
  styleUrls: ['./sales-tax-abstract.component.scss']
})
export class SalesTaxAbstractComponent implements OnInit {

  from_date: any = new Date().toISOString().split('T')[0];
  to_date: any = new Date().toISOString().split('T')[0];
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  document_details: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  total_sale_details: any;
  test_data: any;
  title = null;
  pdf_data: any;


  constructor(private httpService: HttpService, private dom: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }


  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    this.is_document_available = false;
    this.httpService.salesTaxAbstract(data_dict).subscribe((data) => {
      console.log(data);
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_details = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadReportCliked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_details['pdf'];
    // this.test_data = this.dom.bypassSecurityTrustResourceUrl(linkSource);
    const downloadLink = document.createElement("a");
    const fileName = this.document_details['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  getPdf() {
    return this.dom.bypassSecurityTrustResourceUrl(this.pdf_data);
  }

  ngOnInit() {
  }

}
